import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import AuthStore from "../../stores/AuthStore";
import styles from "./index.module.scss";
import AppStore, { TagItem } from "../../stores/User/AppStore";
import { observer } from "mobx-react-lite";
import PageHeader from "./PageHeader";
import PageFooter from "./PageFooter";
import { joinClassNames } from "../../utils";
import { Input } from "antd";
const { Search } = Input;
const UserPage: React.FC = (props) => {
  const { ssoIsLogin } = AuthStore;
  const { projects, versionTypeCur, setVersionTypeCur } = AppStore;
  const navigate = useNavigate();
  const location = useLocation();

  const [isCardType, setIsCardType] = useState<Boolean>(false);

  useEffect(() => {
    if (!ssoIsLogin) {
      navigate("/sso/login");
    } else {
      if (location.pathname.includes("/user")) {
        navigate("/user/cards");
      }
      AppStore.getAppPictureList();
      AppStore.getTag();
    }
  }, [ssoIsLogin]);

  useEffect(() => {
    if (location.pathname.includes("/user/cards")) {
      setIsCardType(true);
    } else if (location.pathname.includes("/user/list")) {
      setIsCardType(false);
    }
  }, [location]);

  const onSearch = async (value: string) => {
    await AppStore.getAppPictureList({
      name: value,
      industryTag: "0",
      otherTag: isCardType ? [versionTypeCur.toString()] : [],
    });
  };

  return (
    <div className={styles.user_page}>
      <PageHeader />
      <div className={styles.main_container}>
        <main className={joinClassNames([styles.main, styles.mainWidth])}>
          <div className={styles.industry_type}>
            {/* <div>
              <span>行业：</span>
              {[{ id: 0, name: "全部", type: "1" }, ...industryTag].map(
                (item: TagItem, index: number) => (
                  <span
                    style={{
                      color: `${
                        typeCurObj.industryTypeCur.index === index
                          ? "#007EF7"
                          : "black"
                      }`,
                    }}
                    onClick={() => {
                      setTypeCurObj({
                        ...typeCurObj,
                        industryTypeCur: {
                          id: String(item.id),
                          index,
                        },
                      });
                    }}
                    key={item.id}
                  >
                    {item.name}
                  </span>
                )
              )}
            </div> */}
          </div>
          <div className={styles.version_type}>
            <div className={styles.version_type_container}>
              {/* <span>其他：</span>
              <div>
                {[{ id: 0, name: "全部", type: "2" }, ...otherTag].map(
                  (item: TagItem, index: number) => (
                    <span
                      className={joinClassNames([
                        `${
                          typeCurObj.versionTypeCur.includes(String(item.id)) &&
                          styles.active
                        }`,
                        styles.tag,
                      ])}
                      onClick={() => {
                        if (index === 0) {
                          setTypeCurObj({
                            ...typeCurObj,
                            versionTypeCur: ["0"],
                          });
                        } else {
                          if (
                            typeCurObj.versionTypeCur.includes(String(item.id))
                          ) {
                            if (typeCurObj.versionTypeCur.length > 1) {
                              setTypeCurObj({
                                ...typeCurObj,
                                versionTypeCur: [
                                  ...typeCurObj.versionTypeCur.filter(
                                    (i) => i != String(item.id)
                                  ),
                                ],
                              });
                            }
                          } else {
                            if (typeCurObj.versionTypeCur[0] === "0") {
                              console.log("!!!!");
                              setTypeCurObj({
                                ...typeCurObj,
                                versionTypeCur: [
                                  ...typeCurObj.versionTypeCur.slice(1),
                                  String(item.id),
                                ],
                              });
                            } else {
                              setTypeCurObj({
                                ...typeCurObj,
                                versionTypeCur: [
                                  ...typeCurObj.versionTypeCur,
                                  String(item.id),
                                ],
                              });
                            }
                          }
                        }
                      }}
                      key={item.id}
                    >
                      {item.name}
                    </span>
                  )
                )}
              </div> */}
            </div>
            <div className={styles.right_box}>
              <Search
                placeholder="输入关键字"
                allowClear
                enterButton="搜索"
                size="middle"
                prefix={<SearchOutlined />}
                onSearch={onSearch}
              />
              <i
                className={joinClassNames([
                  styles.card_type_swith,
                  "iconfont",
                  isCardType ? "pop-iconunorderedlist" : "pop-iconappstore",
                ])}
                onClick={() => {
                  if (projects.length) {
                    setIsCardType(!isCardType);
                    if (isCardType) {
                      AppStore.getAppPictureList();
                      navigate(
                        `/user/list/${projects[0].id}/${projects[0].refUrlAppVoList[0].id}`
                      );
                    } else {
                      navigate("/user/cards");
                    }
                  }
                }}
              />
            </div>
          </div>
          <Outlet />
        </main>
      </div>
      <PageFooter />
    </div>
  );
};

export default observer(UserPage);
